export default function NavBar() {
  return (
    <nav
      className="fixed top-0 left-0 right-0 z-[100] flex items-center justify-between py-[22px] px-[60px] border-b border-[#2a2422] max-md:px-6"
      style={{
        background: 'rgba(6,6,6,0.92)',
        backdropFilter: 'blur(12px)',
        fontFamily: "'Work Sans', sans-serif",
      }}
    >
      <a
        href="#"
        className="font-bold text-[13px] tracking-[0.12em] text-[#faf9f7] no-underline uppercase whitespace-nowrap"
      >
        Jessica <span className="text-[#d43742]">AI</span>
      </a>
      <div className="flex items-center gap-6">
        <a
          href="/dial-back"
          className="text-[12px] font-semibold tracking-[0.1em] text-[#908880] no-underline uppercase transition-colors duration-200 hover:text-[#faf9f7] whitespace-nowrap cursor-pointer"
        >
          Dial-Back
        </a>
        <a
          href="#waitlist"
          className="text-[12px] font-semibold tracking-[0.1em] text-[#908880] no-underline uppercase transition-colors duration-200 hover:text-[#faf9f7] whitespace-nowrap cursor-pointer"
        >
          Join Waitlist
        </a>
      </div>
    </nav>
  );
}
